export default __webpack_public_path__ + "63f866077b94ef6036ad66481de28e48.svg";